export default class ScrollContainer {
    constructor({
                    x, y, scene, width, height, content, scrollMode = 0, fontFamily = 'Splurge',
                    darkColor = 0x964B00, lightColor = 0x402F1D
    }) {
        this.scene = scene;

        this.darkColor = darkColor;
        this.lightColor = lightColor;

        this.fontFamily = fontFamily;

        this.print = this.scene.add.text(0,0,"");

        this.width = width;

        this.scrollablePanel = this.scene.rexUI.add.scrollablePanel({
            x,
            y,
            width,
            height,

            scrollMode,

            /*background: this.scene.add.image(
                this.scene.scale.width / 2,
                this.scene.scale.height / 2,
                "border_filled_large"
            ),*/

            panel: {
                child: this.createPanel(),
                mask: {
                    padding: 1
                },
            },

            slider: {
                track: this.scene.rexUI.add.roundRectangle(0, 0, 20, 10, 10, this.darkColor),
                thumb: this.scene.rexUI.add.roundRectangle(0, 0, 0, 0, 13, this.lightColor),
            },

            space: {
                left: width / 10,
                right: width / 10,
                top: 80,
                bottom: 80,
                panel: 10,
            }
        })
            .layout()
        //.drawBounds(this.scene.add.graphics(), 0xff0000);

        this.updatePanel(this.scrollablePanel, content);
    }

    set visible(value){
        this.scrollablePanel.visible = value
    }

    setDepth(value){
        this.scrollablePanel.setDepth(value);
    }

    createPanel(){
        return this.scene.rexUI.add.fixWidthSizer({
            space: {
                left: 3,
                right: 3,
                top: 3,
                bottom: 3,
                item: 8,
                line: 8,
            }
        })
    }

    show(){
        this.scrollablePanel.visible = true;
    }

    hide(){
        this.scrollablePanel.visible = false;
    }

    updatePanel(panel, content) {
        const sizer = panel.getElement('panel');
        const scene = panel.scene;

        sizer.clear(true);
        let lines = content.split('\n');
        for (let li = 0, lcnt = lines.length; li < lcnt; li++) {
            let words = lines[li].split(' ');
            for (let wi = 0, wcnt = words.length; wi < wcnt; wi++) {
                sizer.add(
                    scene.add.text(0, 0, words[wi], {
                        fontSize: 24,
                        fontFamily: this.fontFamily,
                        wordWrap: {
                            width: this.width,
                            useAdvancedWrap: true
                        }
                    })
                );
            }
            if (li < (lcnt - 1)) {
                sizer.addNewLine();
            }
        }

        panel.layout();
        return panel;
    }
}